import React, { useMemo } from 'react'
import Select from 'react-select'
import HorizontalScroller from 'shared/ui/HorizontalScroller/HorizontalScroller'
import Button from 'shared/ui/Button/Button'
import { useListsTabs } from './hooks/useListsTabs'
import s from './styles/ListsTabs.module.scss'

export const ListsTabs = ({
	badgeIcon: BadgeIcon,
	badgeText = 'Lists:',
	tabs = [],
	activeTab,
	onSelect,
	actions = [],
	showDropdownMedia = null,
	selectPrefixIcon: SelectPrefixIcon,
	selectPrefixText = 'Lists:',
	className,
	rightButton = null,
	classNameActions = '',
	stackOnMobile = false,
}) => {
	const {
		getCount,
		selectOptions,
		selectedOption,
		handleSelect,
		handleSelectChange,
		isShowDropdown,
	} = useListsTabs({ tabs, activeTab, onSelect, showDropdownMedia })

	const formatOptionLabel = useMemo(() => {
		return (opt, meta) => {
			if (meta.context === 'value') {
				return (
					<div className={s.selectValue}>
						<div className={s.selectValue__inner}>
							{SelectPrefixIcon && (
								<span className={s.selectValue__icon}>
									<SelectPrefixIcon />
								</span>
							)}
							<span className={s.selectValue__prefix}>{selectPrefixText}</span>
						</div>
						<span className={s.selectValue__label}>{opt.label}</span>
					</div>
				)
			}

			return <span className={s.selectOption}>{opt.label}</span>
		}
	}, [SelectPrefixIcon, selectPrefixText])

	return (
		<div
			className={`${s.wrap} ${stackOnMobile ? s.wrap_stacked : ''} ${className || ''}`}
		>
			{!isShowDropdown && (
				<div className={s.badge}>
					{BadgeIcon && (
						<div className={s.badge__icon}>
							<BadgeIcon />
						</div>
					)}
					<span className={s.badge__text}>{badgeText}</span>
				</div>
			)}

			<div className={s.inner}>
				{isShowDropdown && (
					<Select
						className={s.select}
						classNamePrefix="lt"
						value={selectedOption}
						options={selectOptions}
						isSearchable={false}
						onChange={handleSelectChange}
						formatOptionLabel={formatOptionLabel}
					/>
				)}

				{!isShowDropdown && (
					<HorizontalScroller
						showArrows={false}
						className={s.tabsScroll}
						wheelMode="autoToScroll"
					>
						<div className={s.tabs}>
							{tabs.map(tab => {
								const value = getCount(tab.id)

								return (
									<div
										key={tab.id}
										className={`${s.tab} ${
											String(activeTab) === String(tab.id) ? s.active : ''
										} ${tab?.isDifferent ? s.next : ''}`}
									>
										<button
											className={s.tab__inner}
											type="button"
											onClick={e => {
												e.preventDefault()
												handleSelect(tab.id)
											}}
										>
											<span className={s.tab__label}>{tab.label}</span>
											{typeof value === 'number' && (
												<span className={s.tab__count}>{value}</span>
											)}
										</button>
									</div>
								)
							})}
						</div>
					</HorizontalScroller>
				)}
			</div>

			{rightButton && (
				<div className={`${s.actions} ${classNameActions}`}>{rightButton}</div>
			)}

			{!rightButton && actions?.length > 0 && (
				<div className={s.actions}>
					{actions.map(a => (
						<Button
							key={a.id}
							variant="icon"
							onClick={a.onClick}
							typeIconHover={a.typeIconHover}
							disabled={a.disabled}
						>
							{a.icon}
						</Button>
					))}
				</div>
			)}
		</div>
	)
}
